<template>
	<PageIntroduction />
	<div class="page-shop u-s-p-t-80">
		<div class="container products_by_category">
			<!-- Shop-Intro -->
			<div
				class="search-results-wrapper u-s-p-b-20"
				v-if="!getStatus.products.loading"
			>
				<h4 v-if="!isAutoSuggest && searchQuery">
					WE FOUND {{ getProducts.products.total }} RESULTS FOR
					<i class="search_query_title">“{{ searchQuery }}”</i> - ({{ sortBy }})
				</h4>
				<h4 class="text-center" v-if="isAutoSuggest">
					Sorry! No Result Found. Showing Relevant Products.
				</h4>
				<div
					v-if="searchQuery"
					class="redirect-link-wrapper"
					@click.prevent="clearSearch"
				>
					<a class="redirect-link" href="#">Clear Search</a>
				</div>
			</div>
			<!-- Shop-Intro /- -->
			<div class="row" :class="{'justify-content-center': isAutoSuggest}">
				<!-- Shop-Left-Side-Bar-Wrapper -->
				<Sidebar
					@filterParams="filterProducts"
					v-if="!isAutoSuggest"
					:show="sidebar_menu_items"
				/>
				<!-- Shop-Left-Side-Bar-Wrapper /- -->
				<!-- Shop-Right-Wrapper -->
				<div class="col-lg-9 col-md-9 col-sm-12" id="search_result_col">
					<!-- Page-Bar -->
					<SortBar @sortBy="SortProducts" />
					<!-- {{getStatus}} -->
					<!-- Page-Bar /- -->
					<!-- Row-of-Product-Container -->
					<div class="row product-container grid-style">
						<ProductLoader v-if="getStatus.products.loading" v-for="i in 9" :key="i" />
						<!-- <Spinner v-if="getStatus.products.loading" style="height: 200px" /> -->
						<!-- Product Not Found -->
						<div
							class="product-not-found"
							v-if="getProducts.products.data.length == 0 && !getStatus.products.loading"
							style="width: 100%"
						>
							<div class="not-found">
								<h2>SORRY!</h2>
								<!-- 28.9844646 -->
								<h6>There is not any products in this category.</h6>
							</div>
						</div>
						<!-- Product Not Found /- -->
						<div
							v-if="!getStatus.products.loading"
							class="products_div"
							ref="product_div"
							id="product_div"
						>
							<Product
								:product="product"
								v-for="product in getProducts.products.data"
								:key="product.id"
								:sortBy="sortBy"
							/>

							<!-- {{getStatus}} -->
							<Spinner
								style="width: 100%; height: 200px"
								v-if="getStatus.updateProducts.loading"
							/>
							<div
								class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
								style="width: 100%"
								v-if="
									!getStatus.updateProducts.loading &&
									getProducts.products.last_page != pageNo &&
									getProducts.products.data.length != 0
								"
							>
								<a class="redirect-link" href="#" @click.prevent="viewMore"
									>View more on this category</a
								>
							</div>
							<div
								class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
								style="width: 100%"
								v-if="
									!getStatus.updateProducts.loading &&
									getProducts.products.last_page == pageNo &&
									getProducts.products.data.length != 0
								"
							>
								<a class="redirect-link">No More Products..</a>
							</div>
						</div>
					</div>
					<!-- Row-of-Product-Container /- -->
				</div>
				<!-- Shop-Right-Wrapper /- -->
			</div>
		</div>
	</div>
	<Footer />
</template>

<script>
	import PageIntroduction from "../components/Shop/PageIntroduction.vue";
	import Footer from "../components/Bottom/Footer.vue";
	import ShopIntro from "../components/Shop/ShopIntro.vue";
	import {publicPath} from "../../vue.config";
	import Spinner from "../components/Loaders/Spinner.vue";
	import Sidebar from "../components/Sections/Products/Sidebar/Sidebar.vue";
	import {mapActions, mapGetters} from "vuex";
	import StarRating from "vue-star-rating";
	import SortBar from "../components/Sections/Products/SortBar/SortBart.vue";
	import {ContentLoader} from "vue-content-loader";
	import {formatCurrency} from "../utils/common_functions";
	import Product from "../components/Sections/Product.vue";
	import ProductLoader from "../components/Loaders/ProductLoader.vue";
	export default {
		components: {
			PageIntroduction,
			Footer,
			ShopIntro,
			Spinner,
			Sidebar,
			StarRating,
			SortBar,
			ContentLoader,
			Product,
			ProductLoader,
		},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
				startY: 0,
				loading: false,
				pageNo: 1,
				params: null,
				sortBy: "featured",
				isAutoSuggest: false,
				searchQuery: "",
				sidebar_menu_items: ["categories", "price_range", "brands", "rating"],
			};
		},
		computed: {
			...mapGetters("products", ["getProducts", "getStatus", "getBrands"]),
			...mapGetters("cat", ["getCategories"]),
			...mapGetters("cart", ["status"]),
		},
		methods: {
			...mapActions("products", ["getProductByCategoryId", "fetchBrands"]),
			...mapActions("cart", ["addToCart"]),
			formatCurrency,
			scroll() {
				const el = document.getElementById("search_result_col");
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
					offset: -100,
				});
			},
			//filter Products By Price.
			filterProducts(params) {
				this.pageNo = 1;
				params.id = this.$route.query.category_id;
				this.params = params;
				this.getProductByCategoryId({
					search: this.searchQuery,
					...this.params,
					sortBy: this.sortBy,
				});
				this.scroll();
			},
			//Sorting Products
			SortProducts(type) {
				this.pageNo = 1; //resetting Pagination.
				this.sortBy = type;
				this.getProductByCategoryId({
					id: this.$route.query.category_id,
					search: this.searchQuery,
					...this.params,
					sortBy: this.sortBy,
				});
			},

			//View More Handler (For Lazy Loading)
			viewMore() {
				this.pageNo = this.pageNo + 1;
				this.getProductByCategoryId({
					id: this.$route.query.category_id,
					search: this.searchQuery,
					...this.params,
					pageNo: this.pageNo,
					sortBy: this.sortBy,
				});
			},
			//clear Search Query
			clearSearch() {
				this.searchQuery = "";
				this.$router.push({name: "Search", query: {q: "", category_id: ""}});
				this.getProductByCategoryId({
					id: "",
					search: this.searchQuery,
				});
				this.scroll();
			},
		},
		mounted() {
			// getting products by categoryID when page loads
			this.searchQuery = this.$route.query.q;
			this.getProductByCategoryId({
				id: this.$route.query.category_id,
				search: this.searchQuery,
			});
			//for now we are fetching brands here
			this.fetchBrands();
			this.scroll();
		},

		beforeUnmount() {
			//BYE :P
			console.log("Bye From Product Search ");
		},
		watch: {
			$route(to, from) {
				if (to.query.category_id || to.query.q) {
					this.isAutoSuggest = false;
					this.searchQuery = this.$route.query.q;
					//when we are on same page, and category id changes.
					this.pageNo = 1;
					this.getProductByCategoryId({
						id: this.$route.query.category_id,
						search: this.$route.query.q,
					});
					this.scroll();
				}
			},
			// getProducts(newVal, oldVal) {
			//   if (newVal.length == 0 && oldVal.length == 0) {
			//     // selected category has no products. this causes infinite call to api. so we are redirecting to home page.
			//     this.$router.push({
			//       name: "Home",
			//     });
			//     useToast().error("No Products In This Category", { timeout: 3000 });
			//     return;
			//   }
			//   //if products are not found with given search query. then we have to search by category id.
			//   if (newVal.length == 0) {
			//     this.isAutoSuggest = true;
			//     this.searchQuery = "";
			//     this.getProductByCategoryId({
			//       id: this.$route.query.category_id,
			//     });
			//   }
			// },
		},
	};
</script>

<style>
	.active {
		font-weight: bold;
	}
	.products_div {
		width: 100%;
		display: flex;
		flex-flow: inherit;
	}
	.search_query_title {
		color: #343a40;
		text-transform: capitalize;
	}
</style>
